export function toAnswerId(surveyId: string, questionId: string): string {
  return `${surveyId}_${questionId}`;
}

export function toSurveyQuestionId(answerId: string): { surveyId: string; questionId: string } {
  const [surveyId, questionId] = answerId.split("_");
  return { surveyId, questionId };
}
